import {
  useMutation,
  type UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { queryKeysDataSyncJob } from './queryKeys';

type DeleteTaskParams = {
  taskId: string;
};

type SuccessResponse = {
  success: boolean;
};

/**
 * Deletes a data sync task.
 */
export const deleteDataSyncTask = async ({
  taskId,
}: DeleteTaskParams): Promise<SuccessResponse> => {
  const response = await vestigasApi
    .delete(`data_sync/sync_task/${taskId}`)
    .json<SuccessResponse>();
  return response;
};

/**
 * React Query mutation hook for deleting a data sync task.
 * Automatically invalidates relevant queries on success.
 *
 * @param options - Additional mutation options
 */
export const useMutationDeleteTask = (
  options?: Omit<
    UseMutationOptions<SuccessResponse, Error, DeleteTaskParams>,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...options,
    mutationFn: deleteDataSyncTask,
    async onSuccess() {
      // Invalidate all data sync queries
      await queryClient.invalidateQueries({
        queryKey: queryKeysDataSyncJob.base(),
      });

      ToastService.success('Sync-Task erfolgreich gelöscht');
    },
  });

  return mutation;
};
